/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react';

class NotFound extends Component {
  render() {
    return (
      <div
        style={{
          textAlign: 'center'
        }}
      >
        <h3>404 Страница не найдена</h3>
        <p>Извините, но страница которую вы ищете не существует.</p>
      </div>
    );
  }
}

export default NotFound;



// WEBPACK FOOTER //
// ./src/components/Common/NotFound/NotFound.js